import { combineReducers } from 'redux';
import { handleRequest, initialRequestState } from 'src/redux/docbase/reducers/requests/helpers';
import { TaskTypes } from 'src/redux/docbase/action_types';


function getRandomTasks(state = initialRequestState(), action) {
  return handleRequest(
    TaskTypes.GET_TASKS_REQUEST,
    TaskTypes.GET_TASKS_SUCCESS,
    TaskTypes.GET_TASKS_FAIL,
    state,
    action
  )
}

function getHistoryTasks(state = initialRequestState(), action) {
  return handleRequest(
    TaskTypes.GET_TASKS_HISTORY_REQUEST,
    TaskTypes.GET_TASKS_HISTORY_SUCCESS,
    TaskTypes.GET_TASKS_HISTORY_FAIL,
    state,
    action
  )
}

function getTasksVerified(state = initialRequestState(), action) {
  return handleRequest(
    TaskTypes.GET_TASKS_VERIFIED_REQUEST,
    TaskTypes.GET_TASKS_VERIFIED_SUCCESS,
    TaskTypes.GET_TASKS_VERIFIED_FAIL,
    state,
    action
  )
}

function getTaskImage(state = initialRequestState(), action) {
  return handleRequest(
    TaskTypes.GET_TASK_IMAGE_REQUEST,
    TaskTypes.GET_TASK_IMAGE_SUCCESS,
    TaskTypes.GET_TASK_IMAGE_FAIL,
    state,
    action
  )
}

function updateTask(state = initialRequestState(), action) {
  return handleRequest(
    TaskTypes.UPDATE_TASK_REQUEST,
    TaskTypes.UPDATE_TASK_SUCCESS,
    TaskTypes.UPDATE_TASK_FAIL,
    state,
    action
  )
}

function getCountTask(state = initialRequestState(), action) {
  return handleRequest(
    TaskTypes.GET_COUNT_TASK_REQUEST,
    TaskTypes.GET_COUNT_TASK_SUCCESS,
    TaskTypes.GET_COUNT_TASK_FAIL,
    state,
    action
  )
}

function verifyTasks(state = initialRequestState(), action) {
  return handleRequest(
    TaskTypes.VERIFY_TASKS_REQUEST,
    TaskTypes.VERIFY_TASKS_SUCCESS,
    TaskTypes.VERIFY_TASKS_FAIL,
    state,
    action
  )
}

function verifyTask(state = initialRequestState(), action) {
  return handleRequest(
    TaskTypes.VERIFY_TASK_REQUEST,
    TaskTypes.VERIFY_TASK_SUCCESS,
    TaskTypes.VERIFY_TASK_FAIL,
    state,
    action
  )
}

function skipTask(state = initialRequestState(), action) {
  return handleRequest(
    TaskTypes.SKIP_TASK_REQUEST,
    TaskTypes.SKIP_TASK_SUCCESS,
    TaskTypes.SKIP_TASK_FAIL,
    state,
    action
  )
}

function synchronizeTasks(state = initialRequestState(), action) {
  return handleRequest(
    TaskTypes.SYNCHRONIZE_TASKS_REQUEST,
    TaskTypes.SYNCHRONIZE_TASKS_SUCCESS,
    TaskTypes.SYNCHRONIZE_TASKS_FAIL,
    state,
    action
  )
}

export default combineReducers({
  getRandomTasks,
  getHistoryTasks,
  getTasksVerified,
  getTaskImage,
  updateTask,
  getCountTask,
  verifyTasks,
  synchronizeTasks,
  verifyTask,
  skipTask,
})